// src/components/ProtectedRoute.js

import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { useAuth } from '../contexts/AuthContext';

/** Matches firestore.rules adminRoles() — founder/superAdmin must reach /admin/*. */
const ADMIN_ROLES = ['admin', 'superAdmin', 'founder'];

const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();
  const [isAdmin, setIsAdmin] = useState(null); // null indicates loading state

  useEffect(() => {
    const fetchUserRole = async () => {
      if (currentUser) {
        try {
          const db = getFirestore();
          const userRoleDoc = await getDoc(doc(db, 'userRoles', currentUser.uid));
          if (userRoleDoc.exists()) {
            const role = userRoleDoc.data()?.role;
            setIsAdmin(ADMIN_ROLES.includes(role));
            return;
          }
          // Fallback: some accounts only have role on users/{uid}
          const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
          const role = userDoc.exists() ? userDoc.data()?.role : null;
          setIsAdmin(ADMIN_ROLES.includes(role));
        } catch (error) {
          console.error('Error fetching user role:', error);
          setIsAdmin(false);
        }
      } else {
        setIsAdmin(false);
      }
    };

    fetchUserRole();
  }, [currentUser]);

  if (isAdmin === null) {
    return (
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <span>Loading...</span>
      </div>
    );
  }

  return isAdmin ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
